import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { PaymentUtilService } from 'src/app/common/payment/services';

@Component({
  selector: 'app-bulkdonation-btn',
  templateUrl: './bulkdonation-btn.component.html',
  styleUrls: ['./bulkdonation-btn.component.scss']
})
export class BulkDonationBtnComponent implements OnInit {

  @Input() config;
  @Output() submitted = new EventEmitter<any>();

  constructor(
    public sheet: MatBottomSheet,
    private paymentutil: PaymentUtilService
  ) { }

  ngOnInit(): void {
  }

  openSheet(template, event) {
    if (this.config.disabled) {
      this.submitted.emit(true);
      return false;
    }
    this.sheet.open(template);
    event.preventDefault();
  }

  closeSheet(template) {
    if (!this.config?.isOrderLoading) {
      this.config.isOrderLoading = true;
    }
    this.paymentutil?.cartResponse.subscribe((res) => {
      if (res) {
        this.sheet.dismiss(template);
        }
      });
    }

}
